<script lang="ts" setup>
import { onBeforeMount, ref } from "vue";
import { useMate } from "@/stores/mate";

const props = defineProps<{
  collection: Collection;
  text?: string;
}>();
const mateStore = useMate();
// const targetMate = ref<Mate | null>(props.collection.mate as Mate);
const isLoadingMate = ref(false);

// onBeforeMount(async () => {
//   if (!(props.storyBook.mate as Mate).name) {
//     isLoadingMate.value = true;
//     try {
//       targetMate.value = (await mateStore.getOrFetchMate(
//         props.storyBook.mate.uuid
//       )) as Mate;
//     } finally {
//       isLoadingMate.value = false;
//     }
//   }
// });
</script>
<template>
  <div class="flex gap-3">
    <div
      class="bg-neutral flex flex-col w-16 aspect-[3/4] rounded overflow-hidden"
    >
      <BaseImg :media="collection.coverMedia" ratio="1:1" />
      <div class="flex flex-1 items-center justify-center">
        <LogoIcon class="w-10 text-base-content" />
      </div>
    </div>
    <div class="flex-1 flex flex-col gap-1">
      <div class="line-clamp-1 text-base">{{ collection.title }}</div>
      <div class="flex flex-col gap-1 text-sm text-base-content/50">
        <div v-if="collection.participantzz" class="line-clamp-3">
          {{ $t("story.author") }}:
          <span v-for="(item, idx) in collection.participantzz" :key="item.id">
            {{ item?.name
            }}<span v-if="idx !== collection.participantzz!.length - 1"
              >,
            </span>
          </span>
        </div>
        <div v-else class="line-clamp-3">
          {{ collection.description }}
        </div>
      </div>
    </div>
  </div>
  <!--  <div class="rounded bg-neutral p-2 flex justify-between items-center">-->
  <!--    <span>1月(上) 排行榜：<span class="text-primary">49名</span></span>-->
  <!--    <span class="btn btn-xs btn-ghost text-base-content/50">-->
  <!--      查看全部排名-->
  <!--      <light-arrow-icon class="icon-xs transform rotate-180" />-->
  <!--    </span>-->
  <!--  </div>-->
  <div
    v-if="text"
    class="text-base-content/50 mt-4"
    v-html="$t('Coin.' + text, { name: collection.title })"
  ></div>
</template>
